// IMPORTS
// Modules
import $ from 'jquery';
// Components
import { OHSCookiesRemove } from './OHSCookies';


// COMPONENT
export default function OHSCRUD (args) {
   // States and Variables
   const baseAPIpath = '/api';

   // Functions
   function performRequest () {
      // Turn On Loading Screen
      if ((args.setOHSLoading) && (args.setOHSLoading !== null)) {
         args.setOHSLoading(true);
      }

      // Hide Confirmation Window
      if ((args.setOHSConfirmation) && (args.setOHSConfirmation !== null)) {
         args.setOHSConfirmation({
            display: false,
            message: null,
            proceed: null,
            yesno: false
         });
      }

      // Perform AJAX Call
      $.ajax({
         url: baseAPIpath + args.url,
         method: args.method,
         data: args.payload,
         contentType: args.file === true ? false : 'application/json',
         dataType: args.file === true ? false : 'json',
         processData: false,
         cache: false,
         async: true
      }).done(function (data) {
         switch (data.status) {
            case 'success':
               // Display Popup Message
               if ((args.setOHSPopup) && (args.setOHSPopup !== null) && (args.showSuccessPopup === true)) {
                  args.setOHSPopup({
                     display: true,
                     title: "Success",
                     message: data.message,
                     severity: 'success',
                     timespan: 3
                  });
               }

               // Perform Success Callback
               if ((args.success) && (args.success !== null)) {
                  args.success(data.payload);
               }
               break;
            case 'error':
               // Display Popup Message
               if ((args.setOHSPopup) && (args.setOHSPopup !== null)) {
                  args.setOHSPopup({
                     display: true,
                     title: "An Error Occurred",
                     message: data.message,
                     severity: 'error'
                  });
               }

               // Perform Error Callback
               if ((args.error) && (args.error !== null)) {
                  args.error(data.message);
               }
               break;
            case 'noauth':
               // Clear Expired Authentication Token
               OHSCookiesRemove('ohs_auth_token');

               // Redirect to Login Page
               window.location.href = '/login';
               break;
         }
      }).fail(function (xhr, status, error) {
         switch (xhr.responseJSON.detail.status) {
            case "noauth":
               // Clear Expired Authentication Token
               OHSCookiesRemove('ohs_auth_token');

               // Redirect to Login Page
               window.location.href = '/login';
               break;
            case "unauth":
               // Display Popup Message
               if ((args.setOHSPopup) && (args.setOHSPopup !== null)) {
                  args.setOHSPopup({
                     display: true,
                     title: error,
                     message: xhr.responseJSON.detail.message,
                     severity: "warning",
                     timespan: 5
                  });
               }

               // Perform Error Callback
               if ((args.unauth) && (args.unauth !== null)) {
                  args.unauth(xhr.responseJSON.detail.message);
               }
               break;
            default:
               // Display Popup Message
               if ((args.setOHSPopup) && (args.setOHSPopup !== null)) {
                  args.setOHSPopup({
                     display: true,
                     title: error,
                     message: xhr.responseJSON.detail.message,
                     severity: xhr.responseJSON.detail.status
                  });
               }

               // Perform Error Callback
               if ((args.error) && (args.error !== null)) {
                  args.error(xhr.responseJSON.detail.message);
               }
               break;
         }
      }).always(function () {
         // Turn Off Loading Screen
         if ((args.setOHSLoading) && (args.setOHSLoading !== null)) {
            args.setOHSLoading(false);
         }

         // Perform Always Callback
         if ((args.always) && (args.always !== null)) {
            args.always();
         }
      });
   }

   // Component
   if ((args.setOHSConfirmation) && (args.setOHSConfirmation !== null)) {
      // Set Confirmation Message
      var message = "Are you sure you wish to continue?";
      if ((args.confirmMessage) && (args.confirmMessage !== null)) {
         message = args.confirmMessage;
      }

      // Show Confirmation Window
      args.setOHSConfirmation({
         display: true,
         message: message,
         proceed: function () {
            performRequest();
         },
         yesno: false
      });
   } else {
      performRequest();
   }
}